export default __webpack_public_path__ + "static/media/main_xl.244af507.jpg";